import { useTranslation } from "react-i18next";
import Button from "../Common/Button";

const ContentConfirmModal = ({
    isOpen,
    isLoading = false,
    title,
    message,
    confirmLabel,
    onConfirm,
    onClose,
}) => {
    const { t } = useTranslation();
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-4 py-6">
            <div className="w-full max-w-md rounded-2xl bg-white p-6 shadow-[0_20px_60px_rgba(0,0,0,0.25)]">
                <h2 className="text-lg font-semibold text-slate-900">{title || t("CONTENT_CONFIRM_TITLE")}</h2>
                <p className="mt-2 text-sm text-slate-500">{message || t("CONTENT_CONFIRM_MESSAGE")}</p>
                <div className="mt-6 flex flex-col gap-3 sm:flex-row sm:justify-end">
                    <Button
                        type="button"
                        onClick={onClose}
                        disabled={isLoading}
                        variant="secondary"
                    >
                        {t("COMMON_CANCEL")}
                    </Button>
                    <Button
                        type="button"
                        onClick={onConfirm}
                        disabled={isLoading}
                    >
                        {isLoading ? t("COMMON_SUBMITTING") : (confirmLabel || t("COMMON_SUBMIT"))}
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default ContentConfirmModal;
